export const PERSONAL_MEDIA_FEATURE_KEY = 'personal-media';
export const PERSONAL_MEDIA_ITEMS_FEATURE_KEY = 'personal-media-items';
